import React from "react";
import { HashRouter, Route, Switch, Redirect } from "react-router-dom";
import JssProvider from 'react-jss/lib/JssProvider';
import { createGenerateClassName } from '@material-ui/core/styles';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';


// components
import Layout from "./Layout";

// pages
import Error from "../pages/error";
import Login from "../pages/login";
import checkTokenService from '../services/checkToken';
import Cookies from 'universal-cookie';

const generateClassName = createGenerateClassName({
  dangerouslyUseGlobalCSS: true, // won't minify CSS classnames when true
  productionPrefix: 'c', // 'jss' by default
});

var isAuthenticated;

export default class App extends React.Component{
  
  constructor() {
    super();
    this.state = {};
  }

  async componentDidMount(){
    this.setState({isLoading: true})
    const cookies = new Cookies();
    var token = cookies.get('token', { path: '/' });
    var uname = cookies.get('username', { path: '/' });
    isAuthenticated = await checkTokenService(uname, token);
    this.setState({isLoading: false})
  }

  render(){

    if (this.state.isLoading === true){
      return <div />;
    }

    const cookies = new Cookies();
    const username = cookies.get('username', { path: '/' });
    const userType = cookies.get('userType', { path: '/' });
    const brokerType = cookies.get('brokerType', { path: '/' });

    var redirectUrl = '';
    if (userType == 2 && brokerType == 'company')
      redirectUrl = "/app/companiesBroker";
    else if (userType == 2 && brokerType == 'investor')
      redirectUrl = "/app/investorsBroker";
    else if (username == "admin") 
      redirectUrl = "/app/accountslist";
    else 
      redirectUrl = "/app/eventslist";

    return (
      <JssProvider generateClassName={ generateClassName }>
      <HashRouter>
        <Switch>

          <Route exact path="/" render={() => <Redirect to={redirectUrl} />} />
          <PrivateRoute path="/app" component={Layout} />
          <PublicRoute path="/login" component={Login} />
          <Route component={Error} />
        </Switch>
      </HashRouter>
      </JssProvider>
    );
    }
  }

  // #######################################################################

  function PrivateRoute({ component, ...rest }) {
    return (
      <Route
        {...rest}
        render={props =>
          isAuthenticated ? (
            React.createElement(component, props)
          ) : (
            <Redirect
              to={{
                pathname: "/login",
                state: {
                  from: props.location,
                },
              }}
            />
          )
        }
      />
    );
  }

  function PublicRoute({ component, ...rest }) {
    return (
      <Route
        {...rest}
        render={props =>
          isAuthenticated ? (
            <Redirect
              to={{
                pathname: "/",
              }}
            />
          ) : (
            React.createElement(component, props)
          )
        }
      />
    );
  }

